import React, { memo } from "react";
import PropTypes from "prop-types";
import { DropdownMenu } from "./SearchOtherLanguagesDropdown.styled";
import { setLangCookie } from "../../shared/_functions/index";

const SearchOtherLanguagesDropdown = (props) => {
  const {
    supportedLanguages,
    defaultIndex,
    hasFetched,
    setSelectedLanguage,
    showTitle,
    size,
  } = props;

  // This will be added to when we are handling cookies for the users language
  const onLanguageSelect = (event, index, item) => {
    if (event && item) {
      setSelectedLanguage(item);
      setLangCookie(item.key);
    }
  };

  return (
    <>
      {hasFetched && supportedLanguages.length > 0 && (
        <DropdownMenu
          listClassName="limitHeight"
          variant="secondary"
          glyph="language"
          options={supportedLanguages}
          defaultIndex={defaultIndex}
          onChange={onLanguageSelect}
          showTitle={showTitle}
          size={size}
          squareRightBorder={true}
        />
      )}
    </>
  );
};

SearchOtherLanguagesDropdown.propTypes = {
  hasFetched: PropTypes.bool,
  defaultIndex: PropTypes.number,
  supportedLanguages: PropTypes.object,
};

export default memo(SearchOtherLanguagesDropdown);
